<template>
    <router-view/>

</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import { mapGetters } from 'vuex';

@Options({
    name:'HomeCrm',
    components: {

    },
    computed: {
        ...mapGetters([
            'me',
        ])
    }
})
export default class HomeCrm extends Vue {

}

</script>


<style lang="scss">

</style>
